import { createContext, useContext, useState, ReactNode } from 'react';

interface RefreshSlot {
    slot: HTMLElement | null,
    setSlot: (el: HTMLElement | null) => void,
}

const RefreshSlotContext = createContext<RefreshSlot>({
    slot: null,
    setSlot: () => { },
});

/**
 * Lets `CasinosList` (which owns polling state) portal its `RefreshIndicator`
 * into a DOM node registered by `CasinoSearchAndSort`, so the indicator can
 * sit inside the search bar row instead of taking its own row.
 */
export function RefreshSlotProvider({ children }: { children: ReactNode }) {
    const [slot, setSlot] = useState<HTMLElement | null>(null);
    return (
        <RefreshSlotContext.Provider value={{ slot, setSlot }}>
            {children}
        </RefreshSlotContext.Provider>
    );
}

export function useRefreshSlot() {
    return useContext(RefreshSlotContext);
}
